import {
GET_STATE_NEW_REQUEST, GET_STATE_NEW_SUCCESS, GET_STATE_NEW_ERROR,

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_STATE_NEW_REQUEST:
            return {
                loading: true,
            };
        case GET_STATE_NEW_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_STATE_NEW_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}